// extracted by mini-css-extract-plugin
module.exports = {"margin_left_20":"FinesQuestion_margin_left_20__3Xs8H","margin_back":"FinesQuestion_margin_back__1S2g0"};